import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as ProjectV2Store from '../../../../../redux/projectsV2';
import Checkbox from '../../../../generic/Forms/Checkbox';
import type { Project } from '../../../../../../shared/projectsV2/response';
import type { ReduxStore } from '../../../../../redux/store';

import ProjectIssueCounts from './ProjectIssueCounts';
import ProjectOverview from './ProjectOverview';
import RevisionTimes from './RevisionTimes';

type Props = {
  project: Project;
};

const ProjectItem: VoidFunctionComponent<Props> = ({ project }: Props) => {
  const dispatch = useDispatch();
  const isSelected =
    useSelector((state: ReduxStore) => ProjectV2Store.selectors.getIsProjectSelected(state, project.id));

  const onSelect = () => isSelected
    ? dispatch(ProjectV2Store.actions.deselectProject(project.id))
    : dispatch(ProjectV2Store.actions.selectProject(project.id));

  return (
    // The checkbox allows for keyboard accessibility.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="project-item" onClick={onSelect}>
      <div className="project-item__checkbox">
        <Checkbox isChecked={isSelected} isRippleDisabled />
      </div>
      <ProjectOverview project={project} />
      <ProjectIssueCounts project={project} />
      <RevisionTimes project={project} />
    </div>
  );
};

export default ProjectItem;
